export default [
  {
    _id: 'contact-001',
    childId: 'child-001',
    memberId: 'member-001',
    type: 'phone',
    direction: 'outbound',
    summary: 'Discussed transition plan and weekend visit logistics.',
    at: '2025-01-06T20:30:00.000Z',
    createdBy: 'caseworker.jordan@safegenerations.org',
    attachments: []
  },
  {
    _id: 'contact-002',
    childId: 'child-001',
    memberId: 'member-002',
    type: 'text',
    direction: 'inbound',
    summary: 'Marcus shared updated phone number and availability.',
    at: '2024-12-20T18:00:00.000Z',
    createdBy: 'caseworker.jordan@safegenerations.org',
    attachments: []
  },
  {
    _id: 'contact-003',
    childId: 'child-001',
    memberId: 'member-003',
    type: 'meeting',
    direction: 'manual',
    summary: 'Quarterly academic review and support plan update.',
    at: '2024-11-18T17:45:00.000Z',
    createdBy: 'caseworker.jordan@safegenerations.org',
    attachments: []
  }
];
